module.exports = __webpack_public_path__ + "7823eebaff60977a02875f21988fac64.png";